import CompanyCustomAttributes from 'pages/organisations/companies/v5/tabs/CompanyCustomAttributes';

const WholesalerCustomAttributes = (props) => (
    <CompanyCustomAttributes {...props} />
);

export default WholesalerCustomAttributes;
